import {API, Auth} from 'aws-amplify';



function getMyInitiDocumentDb(params) {

    let skip = 0;
    let command = "find"
    if (params.hasOwnProperty('skip'))
        skip = params.skip * 20;
    if (params.hasOwnProperty('command'))
        command = params.command;

    let myInitDb = {
        body: {
            "database": process.env.REACT_APP_DATABASE,
            "collection": params.collection,
            "command": command,
            skip: skip,
            limit: 20,
            "query": {},

        },
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}


function getMyInitiDocumentDbCollection(body) {
    const { attributes } =  Auth.currentAuthenticatedUser();
    let myInitDb = {
        body: body,
        headers: {
            'Access-Control-Allow-Headers': 'Content-Type',
            'Access-Control-Allow-Origin': 'http://localhost:3000',
            'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
            drtoken: localStorage.getItem('token')
        }
    };
    return myInitDb;
}


export default {
    getCollections: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDbCollection({
            "database": "db-pipeline",
            "collection": "masterdata-environment",
            "command": "find",
            "query": {
                "client": process.env.REACT_APP_X_TENANT_ID
            }
        })).then(response => {
            return response.response;
        }),

    getBase: (params) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb(params)).then(response => {
            return response.response;
        }),

    getBaseCount: (params) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb(params)).then(response => {
            return response.response;
        }),

    getSKU: ({}) =>
        API.post('dr', '/mongoDB', getMyInitiDocumentDb({
            "database": process.env.REACT_APP_DATABASE,
            "collection": process.env.REACT_APP_COLLECTION_PREFIX + "_sku_silver_ok",
            "command": "find",
            "limit": 500,
            "query": {},
            "projection": {
                "sku": 1,
                "material_description_en": 1,
                "marca": 1,
                "category_sku": 1,
                "categoria_principal_sku": 1,
                "sub_categoria_sku": 1,
                "hero": 1,
                "abcd": 1,
                "plc_local": 1,
                "plc_global": 1,
                "data_validade_sku": 1,
                "creationDate": 1
            }
        })).then(response => {
            return response.response;
        }),

};
